import ElementUI from 'element-ui';
export default {
	IEVersion: function() {
		var versions = '';
		var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
		var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
		var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
		var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;

		if (isIE) {
			var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
			reIE.test(userAgent);
			var fIEVersion = parseFloat(RegExp["$1"]);
			if (fIEVersion == 7) {
				versions = 7;
			} else if (fIEVersion == 8) {
				versions = 8;
			} else if (fIEVersion == 9) {
				versions = 9;
			} else if (fIEVersion == 10) {
				versions = 10;
			} else {
				versions = 6; //IE版本<=7
			}
		} else if (isEdge) {
			versions = 'edge'; //edge
		} else if (isIE11) {
			versions = 11; //IE11
		} else {
			versions = 'webkit'; //不是ie浏览器
		}
		if (versions < 10) {
			ElementUI.MessageBox({
				title: '提示',
				message: '当前浏览器版本过低，为了您的正常使用，请升级浏览器或者使用其他浏览器',
				confirmButtonText: '去升级',
        showClose:false,
        showCancelButton:false,
        closeOnClickModal:false,
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
            window.location.href ='https://www.google.cn/intl/zh-CN/chrome/browser/desktop/'
						done();
					} else {
						done();
					}

				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/util.js